import { useState, useEffect } from "react";

// Owner-only "Changelog View" toggle — mirrors useRoadmapView. When ON, the nav
// shows per-page change badges + a floating right-side panel of recent edits.
// Persisted in localStorage; a custom event keeps toggle/badges/panel in step.
const KEY = "rosterly-changelog-view";
const SEEN_COUNTS = "rosterly-changelog-seen-counts";
const EVT = "rosterly-changelog-view";

export function readChangelogView() {
    try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
}

export function setChangelogView(on) {
    try { localStorage.setItem(KEY, on ? "1" : "0"); } catch { /* ignore */ }
    window.dispatchEvent(new Event(EVT));
}

// Per-area "seen" counts: { "/rosters": 12, ... } — the change count for an area
// at the moment the owner last opened its changelog. The nav badge shows only
// the NEW changes since (currentCount - seenCount).
export function readChangelogSeen() {
    try { return JSON.parse(localStorage.getItem(SEEN_COUNTS) || "{}") || {}; } catch { return {}; }
}

export function markAreaSeen(area, count) {
    if (!area) return;
    try {
        const cur = readChangelogSeen();
        if (cur[area] === count) return;   // no change → avoid needless re-render loop
        cur[area] = count;
        localStorage.setItem(SEEN_COUNTS, JSON.stringify(cur));
    } catch { /* ignore */ }
    window.dispatchEvent(new Event(EVT));
}

export function useChangelogView() {
    const [on, setOn] = useState(readChangelogView);
    useEffect(() => {
        const update = () => setOn(readChangelogView());
        window.addEventListener(EVT, update);
        return () => window.removeEventListener(EVT, update);
    }, []);
    return on;
}

export function useChangelogSeen() {
    const [seen, setSeen] = useState(readChangelogSeen);
    useEffect(() => {
        const update = () => setSeen(readChangelogSeen());
        window.addEventListener(EVT, update);
        return () => window.removeEventListener(EVT, update);
    }, []);
    return seen;
}
